import { defineStore } from 'pinia'
import { ref } from 'vue'
import { notify } from '@nimling/components-nimtech'
import type { Annotation } from '@/types'
import * as api from '@/lib/api'

export const useAnnotationsStore = defineStore('annotations', () => {
  const annotations = ref<Annotation[]>([])
  const loaded = ref(false)

  const getAnnotations = async (): Promise<Annotation[]> => {
    annotations.value = await api.getAnnotations()
    loaded.value = true
    return annotations.value
  }

  const postAnnotation = async (input: Partial<Annotation>): Promise<Annotation> => {
    const created = await api.postAnnotation(input)
    annotations.value = [created, ...annotations.value]
    notify('success', `Annotation "${created.title}" added`)
    return created
  }

  const deleteAnnotation = async (id: string): Promise<void> => {
    await api.deleteAnnotation(id)
    annotations.value = annotations.value.filter((a) => a.id !== id)
    notify('info', 'Annotation removed')
  }

  return { annotations, loaded, getAnnotations, postAnnotation, deleteAnnotation }
})
